import { Network } from '@kattana-io/common';
import { connect } from 'react-redux';
import { IStore } from '../../../reducers';
import { useSignData } from '../../Trading/hooks';
import { ICoin } from '../../Trading/reducers/tradingReducer';
import './styles.scss';
import { useNetwork } from 'wagmi';
import { KattanaAPI } from '../../../store/createStore';

export interface OrderPayload {
  src: string;
  dest: string;
  pair?: string;
  flipped: boolean;
  price: number;
  price_usd: number;
  gt: boolean;
  proxy: string;
  amount_in: number;
  amount_out: number;
  protocol?: string;
}

export interface IModalLimitProps {
  payload: OrderPayload;
  info: {
    base: ICoin;
    quote: ICoin;
  };
}

interface IProps {
  modalProps: IModalLimitProps;
  actionCloseModal: () => void;
}

const LimitOrderCreated = ({ actionCloseModal, modalProps }: IProps) => {
  const { signData } = useSignData();
  const { info, payload } = modalProps;
  const { chain } = useNetwork();

  const onClick = async () => {
    const chainId = chain?.id;
    const net = Network.fromChainId(chainId);

    const result = await signData({
      ...payload,
      network: net?.toDecimal(),
    });

    await KattanaAPI.createOrder(result.address, result);
    actionCloseModal();
  };

  return (
    <>
      <div className='limitModal'>
        <div className='limitModal__close' onClick={actionCloseModal} />
        <div className='limitModal__title'>Limit order</div>
        <div className='limitModal__description'>
          When price of {info.base.name}/{info.quote.name} moves up to{' '}
          <strong>{payload.price}</strong> a trade will be issued to{' '}
          <strong>
            sell {payload.amount_in} {info.base.name}
          </strong>
        </div>
        <div className='limitModal__button' onClick={onClick}>
          Confirm
        </div>
      </div>
      <div className='limitModal__backdrop' onClick={actionCloseModal} />
    </>
  );
};

const mapStateToProps = (state: IStore) => ({
  modalProps: state.modal.props,
});

export default connect(mapStateToProps)(LimitOrderCreated);
